<template>
  <div class="lixil">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div class="bom-list">
      <table>
        <tr>
          <th v-for="(title, index) in csvHeader" :key="index">
              {{ title }}
          </th>
        </tr>
        <tr>
          <td v-for="(data, index) in csvDataList" :key="index">
            {{ data }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import {API_URL} from '../../constants/App'
import Modal from '../../components/common/Modal'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'LixilPreview',
  components: {
    'dd-modal': Modal,
    'dd-loading-modal': LoadingModal
  },
  props: {
    orderCode: String,
    spaceJoincd: String
  },
  data () {
    return {
      csvDataMap: {},
      csvHeader: {},
      csvDataList: {},
      // テーブルの行数
      tableRawNum: 0
    }
  },
  methods: {
    getCsvData: function () {
      let urlStr = API_URL.PREVIEW + '/lixil/' + this.spaceJoincd
      this.$refs.loadingModalRef.showModal(true)
      axios.get(urlStr)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          console.log('▼▼▼▼ DEBUG:GET BOM DATA ▼▼▼▼')
          console.log(response)
          console.log('▲▲▲▲ DEBUG:GET BOM DATA ▲▲▲▲')
          // レスポンス取得
          let csvDataMap = response.data.data
          // BOMの設定
          this.csvHeader = csvDataMap[0]
          this.csvDataList = csvDataMap[1]
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    }
  },
  mounted: function () {
    this.getCsvData()
  }
}
</script>
<style lang="scss" scoped>
.lixil {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow: auto;
}
table {
  width: auto;
  td {
    white-space: nowrap;
    border: 1px solid #ddd;
    min-width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/LixilPreview.vue